import type { CrmMessages } from "./englishCrmMessages";

export const spanishCrmMessages: CrmMessages = {
  resources: {
    companies: {
      name: "Empresa |||| Empresas",
      forcedCaseName: "Empresa",
      fields: {
        name: "Nombre de la empresa",
        website: "Sitio web",
        linkedin_url: "URL de LinkedIn",
        phone_number: "Teléfono",
        created_at: "Fecha de creación",
        nb_contacts: "Número de contactos",
        revenue: "Ingresos",
        sector: "Sector",
        size: "Tamaño",
        tax_identifier: "RFC / Identificador fiscal",
        address: "Dirección",
        city: "Ciudad",
        zipcode: "Código postal",
        state_abbr: "Estado",
        country: "País",
        description: "Descripción",
        context_links: "Enlaces de contexto",
        sales_id: "Vendedor responsable",
      },
      empty: {
        description: "Tu lista de empresas está vacía.",
        title: "No se encontraron empresas",
      },
      field_categories: {
        contact: "Contacto",
        additional_info: "Información adicional",
        address: "Dirección",
        context: "Contexto",
      },
      action: {
        create: "Crear empresa",
        edit: "Editar empresa",
        new: "Nueva empresa",
        show: "Ver empresa",
      },
      added_on: "Agregada el %{date}",
      followed_by: "Seguida por %{name}",
      followed_by_you: "La sigues tú",
      no_contacts: "Sin contactos",
      nb_contacts: "%{smart_count} contacto |||| %{smart_count} contactos",
      nb_deals: "%{smart_count} oportunidad |||| %{smart_count} oportunidades",
      sizes: {
        one_employee: "1 empleado",
        two_to_nine_employees: "2-9 empleados",
        ten_to_forty_nine_employees: "10-49 empleados",
        fifty_to_two_hundred_forty_nine_employees: "50-249 empleados",
        two_hundred_fifty_or_more_employees: "250 o más empleados",
      },
      autocomplete: {
        create_error: "Ocurrió un error al crear la empresa",
        create_item: "Crear %{item}",
        create_label: "Escribe para crear una empresa nueva",
      },
      filters: {
        only_mine: "Solo las empresas que manejo",
      },
    },
    contacts: {
      name: "Contacto |||| Contactos",
      forcedCaseName: "Contacto",
      field_categories: {
        background_info: "Antecedentes",
        identity: "Identidad",
        misc: "Otros",
        personal_info: "Información personal",
        position: "Puesto",
      },
      fields: {
        first_name: "Nombre",
        last_name: "Apellido",
        last_seen: "Último contacto",
        title: "Cargo",
        company_id: "Empresa",
        email_jsonb: "Correos electrónicos",
        email: "Correo electrónico",
        phone_jsonb: "Teléfonos",
        phone_number: "Teléfono",
        linkedin_url: "URL de LinkedIn",
        background: "Antecedentes (biografía, cómo lo conociste, etc.)",
        has_newsletter: "Suscrito al boletín",
        sales_id: "Vendedor responsable",
      },
      action: {
        add: "Agregar contacto",
        add_first: "Agrega tu primer contacto",
        create: "Crear contacto",
        edit: "Editar contacto",
        export_vcard: "Exportar a vCard",
        new: "Nuevo contacto",
        show: "Ver contacto",
      },
      background: {
        last_activity_on: "Última actividad el %{date}",
        added_on: "Agregado el %{date}",
        followed_by: "Seguido por %{name}",
        followed_by_you: "Lo sigues tú",
        status_none: "Ninguno",
      },
      position_at: "%{title} en",
      position_at_company: "%{title} en %{company}",
      empty: {
        description: "Tu lista de contactos está vacía.",
        title: "No se encontraron contactos",
      },
      import: {
        title: "Importar contactos",
        button: "Importar CSV",
        complete:
          "Importación completa. %{importCount} contactos importados, con %{errorCount} errores.",
        progress:
          "Importados %{importCount} / %{rowCount} contactos, con %{errorCount} errores.",
        error:
          "No se pudo importar el archivo. Verifica que sea un CSV válido.",
        imported: "Importados",
        remaining_time: "Tiempo estimado restante:",
        running:
          "La importación está corriendo, no cierres esta pestaña.",
        sample_download: "Descargar CSV de ejemplo",
        sample_hint:
          "Aquí tienes un CSV de ejemplo que puedes usar como plantilla",
        stop: "Detener importación",
        csv_file: "Archivo CSV",
        contacts_label: "contacto |||| contactos",
      },
      inputs: {
        genders: {
          male: "Él",
          female: "Ella",
          nonbinary: "Elle",
        },
        personal_info_types: {
          work: "Trabajo",
          home: "Personal",
          other: "Otro",
        },
      },
      list: {
        error_loading: "Error al cargar los contactos",
      },
      bulk_tag: {
        action: "Etiquetar",
        back: "Volver a etiquetas",
        create_description:
          "Crea una etiqueta nueva y aplícala a los contactos seleccionados.",
        description:
          "Elige una etiqueta existente o crea una nueva para los contactos seleccionados.",
        empty:
          "Aún no hay etiquetas. Crea una para etiquetar los contactos seleccionados.",
        error: "No se pudo agregar la etiqueta a los contactos",
        noop: "Los contactos seleccionados ya tienen esta etiqueta",
        success:
          "Etiqueta agregada a %{smart_count} contacto |||| Etiqueta agregada a %{smart_count} contactos",
        title: "Agregar etiqueta a contactos",
      },
      merge: {
        action: "Fusionar con otro contacto",
        confirm: "Fusionar contactos",
        current_contact: "Contacto actual (se eliminará)",
        description: "Fusiona este contacto con otro.",
        error: "No se pudo fusionar los contactos",
        merging: "Fusionando...",
        no_additional_data: "No hay datos adicionales para fusionar",
        select_target: "Selecciona un contacto para fusionar",
        success: "Contactos fusionados con éxito",
        target_contact: "Contacto destino (se conservará)",
        title: "Fusionar contacto",
        warning_description:
          "Todos los datos se transferirán al segundo contacto. Esta acción no se puede deshacer.",
        warning_title: "Atención: operación destructiva",
        what_will_be_merged: "Lo que se va a fusionar:",
      },
      filters: {
        before_last_month: "Antes del mes pasado",
        before_this_month: "Antes de este mes",
        before_this_week: "Antes de esta semana",
        managed_by_me: "Que yo manejo",
        search: "Buscar nombre, empresa...",
        this_week: "Esta semana",
        today: "Hoy",
        tags: "Etiquetas",
        tasks: "Tareas",
      },
      hot: {
        empty_change_status:
          'Cambia el estado de un contacto agregando una nota y haciendo clic en "ver opciones".',
        empty_hint:
          'Los contactos con estado "caliente" aparecerán aquí.',
        title: "Contactos calientes",
      },
    },
    deals: {
      name: "Oportunidad |||| Oportunidades",
      fields: {
        name: "Nombre",
        description: "Descripción",
        company_id: "Empresa",
        contact_ids: "Contactos",
        category: "Categoría",
        amount: "Monto",
        expected_closing_date: "Fecha estimada de cierre",
        stage: "Etapa",
      },
      action: {
        back_to_deal: "Volver a la oportunidad",
        create: "Crear oportunidad",
        new: "Nueva oportunidad",
      },
      field_categories: {
        misc: "Otros",
      },
      archived: {
        action: "Archivar",
        error: "Error: no se archivó la oportunidad",
        list_title: "Oportunidades archivadas",
        success: "Oportunidad archivada",
        title: "Oportunidad archivada",
        view: "Ver oportunidades archivadas",
      },
      inputs: {
        linked_to: "Vinculada a",
      },
      unarchived: {
        action: "Regresar al pipeline",
        error: "Error: no se desarchivó la oportunidad",
        success: "Oportunidad desarchivada",
      },
      updated: "Oportunidad actualizada",
      empty: {
        before_create: "antes de crear una oportunidad.",
        description: "Tu lista de oportunidades está vacía.",
        title: "No se encontraron oportunidades",
      },
      invalid_date: "Fecha inválida",
    },
    notes: {
      name: "Nota |||| Notas",
      forcedCaseName: "Nota",
      fields: {
        status: "Estado",
        date: "Fecha",
        attachments: "Archivos adjuntos",
        contact_id: "Contacto",
        deal_id: "Oportunidad",
      },
      action: {
        add: "Agregar nota",
        add_first: "Agrega tu primera nota",
        delete: "Eliminar nota",
        edit: "Editar nota",
        update: "Actualizar nota",
        add_this: "Agregar esta nota",
      },
      sheet: {
        create: "Crear nota",
        create_for: "Crear nota para %{name}",
        edit: "Editar nota",
        edit_for: "Editar nota para %{name}",
      },
      deleted: "Nota eliminada",
      empty: "Aún no hay notas",
      author_added: "%{name} agregó una nota",
      you_added: "Agregaste una nota",
      me: "Yo",
      list: {
        error_loading: "Error al cargar las notas",
      },
      note_for_contact: "Nota para %{name}",
      stepper: {
        hint: "Ve a la página de un contacto y agrega una nota",
      },
      added: "Nota agregada",
      inputs: {
        add_note: "Agregar una nota",
        options_hint: "(adjunta archivos o cambia detalles)",
        show_options: "Ver opciones",
      },
      actions: {
        attach_document: "Adjuntar documento",
      },
      validation: {
        note_or_attachment_required: "Se requiere una nota o un archivo",
      },
    },
    sales: {
      name: "Usuario |||| Usuarios",
      fields: {
        first_name: "Nombre",
        last_name: "Apellido",
        email: "Correo electrónico",
        administrator: "Administrador",
        disabled: "Deshabilitado",
      },
      create: {
        error: "Ocurrió un error al crear el usuario.",
        success:
          "Usuario creado. Comparte las credenciales con el usuario o pídele que use 'Olvidé mi contraseña' en la pantalla de login.",
        title: "Crear un usuario nuevo",
      },
      edit: {
        error: "Ocurrió un error. Inténtalo de nuevo.",
        record_not_found: "Registro no encontrado",
        success: "Usuario actualizado con éxito",
        title: "Editar %{name}",
      },
      action: {
        new: "Nuevo usuario",
      },
    },
    tasks: {
      name: "Tarea |||| Tareas",
      forcedCaseName: "Tarea",
      fields: {
        text: "Descripción",
        due_date: "Fecha límite",
        type: "Tipo",
        contact_id: "Contacto",
        due_short: "vence",
      },
      action: {
        add: "Agregar tarea",
        create: "Crear tarea",
        edit: "Editar tarea",
      },
      actions: {
        postpone_next_week: "Posponer a la próxima semana",
        postpone_tomorrow: "Posponer para mañana",
        title: "acciones de tarea",
      },
      added: "Tarea agregada",
      deleted: "Tarea eliminada con éxito",
      dialog: {
        create: "Crear tarea",
        create_for: "Crear tarea para %{name}",
      },
      sheet: {
        edit: "Editar tarea",
        edit_for: "Editar tarea para %{name}",
      },
      empty: "Aún no hay tareas",
      empty_list_hint:
        "Las tareas que agregues a tus contactos aparecerán aquí.",
      filters: {
        later: "Más tarde",
        overdue: "Vencidas",
        this_week: "Esta semana",
        today: "Hoy",
        tomorrow: "Mañana",
        with_pending: "Con tareas pendientes",
      },
      regarding_contact: "(Sobre: %{name})",
      updated: "Tarea actualizada",
    },
    tags: {
      name: "Etiqueta |||| Etiquetas",
      action: {
        add: "Agregar etiqueta",
        create: "Crear nueva etiqueta",
      },
      dialog: {
        color: "Color",
        create_title: "Crear nueva etiqueta",
        edit_title: "Editar etiqueta",
        name_label: "Nombre de la etiqueta",
        name_placeholder: "Escribe el nombre",
      },
    },
  },
  crm: {
    action: {
      reset_password: "Restablecer contraseña",
    },
    auth: {
      first_name: "Nombre",
      last_name: "Apellido",
      confirm_password: "Confirmar contraseña",
      confirmation_required:
        "Sigue el enlace que te enviamos por correo para confirmar tu cuenta.",
      recovery_email_sent:
        "Si eres un usuario registrado, recibirás pronto un correo para restablecer tu contraseña.",
      sign_in_failed: "No se pudo iniciar sesión.",
      sign_in_google_workspace: "Iniciar sesión con Google Workspace",
      signup: {
        create_account: "Crear cuenta",
        create_first_user:
          "Crea el primer usuario para completar la configuración.",
        creating: "Creando...",
        initial_user_created: "Usuario inicial creado con éxito",
      },
      welcome_title: "Bienvenido a Musco CRM",
    },
    common: {
      activity: "Actividad",
      added: "agregado",
      details: "Detalles",
      last_activity_with_date: "última actividad %{date}",
      load_more: "Ver más",
      misc: "Otros",
      past: "Pasado",
      read_more: "Leer más",
      retry: "Reintentar",
      show_less: "Ver menos",
      copied: "¡Copiado!",
      copy: "Copiar",
      loading: "Cargando...",
      me: "Yo",
      task_count: "%{smart_count} tarea |||| %{smart_count} tareas",
    },
    changelog: {
      title: "Historial de cambios",
    },
    activity: {
      added_company: "%{name} agregó la empresa",
      you_added_company: "Agregaste la empresa",
      added_contact: "%{name} agregó",
      you_added_contact: "Agregaste",
      added_note: "%{name} agregó una nota sobre",
      you_added_note: "Agregaste una nota sobre",
      added_note_about_deal:
        "%{name} agregó una nota sobre la oportunidad",
      you_added_note_about_deal:
        "Agregaste una nota sobre la oportunidad",
      added_deal: "%{name} agregó la oportunidad",
      you_added_deal: "Agregaste la oportunidad",
      at_company: "en",
      to: "a",
      load_more: "Ver más actividad",
    },
    dashboard: {
      deals_chart: "Ingresos proyectados",
      deals_pipeline: "Pipeline de oportunidades",
      latest_activity: "Actividad reciente",
      latest_activity_error: "Error al cargar la actividad reciente",
      latest_notes: "Mis notas recientes",
      latest_notes_added_ago: "agregada %{timeAgo}",
      stepper: {
        install: "Configurar Musco CRM",
        progress: "%{step}/3 listo",
        whats_next: "¿Qué sigue?",
      },
      upcoming_tasks: "Próximas tareas",
    },
    header: {
      import_data: "Importar datos",
    },
    image_editor: {
      change: "Cambiar",
      drop_hint:
        "Arrastra un archivo para subir o haz clic para seleccionar.",
      editable_content: "Contenido editable",
      title: "Subir y redimensionar imagen",
      update_image: "Actualizar imagen",
    },
    import: {
      action: {
        download_error_report: "Descargar reporte de errores",
        import: "Importar",
        import_another: "Importar otro archivo",
      },
      error: {
        unable: "No se pudo importar este archivo.",
      },
      idle: {
        description_1:
          "Puedes importar vendedores, empresas, contactos, notas y tareas.",
        description_2:
          "Los datos deben estar en un archivo JSON con el siguiente formato:",
      },
      status: {
        all_success: "Todos los registros se importaron con éxito.",
        complete: "Importación completa.",
        failed: "Falló",
        imported: "Importados",
        in_progress:
          "Importación en proceso, no salgas de esta página.",
        some_failed: "Algunos registros no se importaron.",
        table_caption: "Estado de la importación",
      },
      title: "Importar datos",
    },
    settings: {
      about: "Acerca de",
      companies: {
        sectors: "Sectores",
      },
      dark_mode_logo: "Logo modo oscuro",
      deals: {
        categories: "Categorías",
        currency: "Moneda",
        pipeline_help:
          "Selecciona qué etapas cuentan como oportunidades activas del pipeline.",
        pipeline_statuses: "Estados del pipeline",
        stages: "Etapas",
      },
      light_mode_logo: "Logo modo claro",
      notes: {
        statuses: "Estados",
      },
      reset_defaults: "Restablecer valores predeterminados",
      save_error: "No se pudo guardar la configuración",
      saved: "Configuración guardada con éxito",
      saving: "Guardando...",
      tasks: {
        types: "Tipos",
      },
      preferences: "Preferencias",
      title: "Configuración",
      app_title: "Título de la aplicación",
      sections: {
        branding: "Identidad",
      },
      validation: {
        duplicate: "Duplicado %{display_name}: %{items}",
        in_use:
          "No se puede eliminar %{display_name} que aún se usa en oportunidades: %{items}",
        validating: "Validando…",
        entities: {
          categories: "categorías",
          stages: "etapas",
        },
      },
    },
    theme: {
      dark: "Oscuro",
      label: "Tema",
      light: "Claro",
      system: "Sistema",
    },
    language: "Idioma",
    navigation: {
      label: "Navegación CRM",
    },
    profile: {
      inbound: {
        description:
          "Puedes empezar a enviar correos a la dirección de correo entrante de tu servidor, por ejemplo agregándola al campo %{field}. Musco CRM procesará los correos y agregará notas a los contactos correspondientes.",
        title: "Correo entrante",
      },
      mcp: {
        title: "Servidor MCP",
        description:
          "Usa esta URL para conectar tu asistente de IA a los datos del CRM vía Model Context Protocol (MCP).",
      },
      password: {
        change: "Cambiar contraseña",
      },
      password_reset_sent:
        "Se envió un correo para restablecer la contraseña a tu dirección de correo.",
      record_not_found: "Registro no encontrado",
      title: "Perfil",
      updated: "Tu perfil se actualizó",
      update_error: "Ocurrió un error. Inténtalo de nuevo.",
    },
    validation: {
      invalid_url: "Debe ser una URL válida",
      invalid_linkedin_url: "La URL debe ser de linkedin.com",
    },
  },
};
